import appSync from '@/_services/appsync.service.js'
import gql from 'graphql-tag'
import moment from 'moment-timezone'

export const shipmentGroupByDayService = {
  Shipments,
  ShipmentsFacets
}

const SEARCH_SHIPMENTS = gql`query search($input: SearchInput!) {
  search(input: $input) {
    results {
      ... on ShipmentsDayOverview {
        date
        metrics {
          count
          stops
          weight
          volume
          price {
            price
            currency
          }
        }
        shipments {
          ... on NotTypedShipment {
            id
            labels
            status
            createdAt
            updatedAt
            warnings
            type
            drops {
              weight
              volume
            }
            quoting {
              quotingStatus
              noOfRequests
              noOfQuotes
              selectedQuote {
                status
              }
            }
            arrivalUTC
            departureUTC
            pickupLocal {
              from
              to
            }
            deliveryLocal {
              from
              to
            }
            goodsValue {
              price,
              currency
            }
            # pricing {
            #   price
            #   currency
            # }
          }
          ... on Shipment1PL {
            id
            labels
            status
            createdAt
            updatedAt
            warnings
            type
            pickupLocal {
              from
              to
            }
            deliveryLocal {
              from
              to
            }
            arrivalUTC
            departureUTC
            drops {
              weight
              volume
            }
            schedule {
              metrics {
                totalDistance
                totalDuration
                numberOfLocations
                numberOfOtherStops
              }
            }
            quoting {
              quotingStatus
              noOfRequests
              noOfQuotes
              selectedQuote {
                quoteID
                price
                currency
                status
              }
            }
            pricing {
              price
              currency
            }
            goodsValue {
              price,
              currency
            }
            vehicle {
              # name
              model
              type
              plateNumber
              maxWeight
              maxVolume
              organization {
                id
                name
              }
              equipment
              labels
              loadArea {
                height
                length
                maxWeight
                width
              }
            }
            driver
          }
          ... on Shipment2PL {
            id
            labels
            status
            createdAt
            updatedAt
            warnings
            type
            pickupLocal {
              from
              to
            }
            deliveryLocal {
              from
              to
            }
            arrivalUTC
            departureUTC
            drops {
              weight
              volume
            }
            schedule {
              metrics {
                totalDistance
                totalDuration
                numberOfLocations
                numberOfOtherStops
              }
            }
            quoting {
              quotingStatus
              noOfRequests
              noOfQuotes
              selectedQuote {
                status
              }
            }
            pricing {
              price
              currency
            }
            goodsValue {
              price,
              currency
            }
            vehicleClass {
              # maxWeight
              # maxVolume
              type
              organization {
                id
                name
              }
              equipment
            }
          }
          ... on ShipmentExpress {
            id
            labels
            status
            createdAt
            updatedAt
            warnings
            type
            drops {
              weight
              volume
            }
            quoting {
              quotingStatus
              noOfRequests
              noOfQuotes
              selectedQuote {
                status
              }
            }
            pricing {
              price
              currency
            }
            goodsValue {
              price,
              currency
            }
            arrivalUTC
            departureUTC
          }
          ... on Shipment3PL {
            id
            labels
            status
            createdAt
            updatedAt
            warnings
            type
            drops {
              weight
              volume
            }
            quoting {
              quotingStatus
              noOfRequests
              noOfQuotes
              selectedQuote {
                quoteID
                price
                currency
                status
                organization {
                  id
                  name
                }
              }
            }
            pricing {
              price
              currency
            }
            goodsValue {
              price,
              currency
            }
            pickupLocal {
              from
              to
            }
            deliveryLocal {
              from
              to
            }
            arrivalUTC
            departureUTC
          }
          ... on ShipmentLTL {
            id
            labels
            status
            createdAt
            updatedAt
            warnings
            drops {
              weight
              volume
            }
            quoting {
              quotingStatus
              noOfRequests
              noOfQuotes
              selectedQuote {
                status
              }
            }
            pricing {
              price
              currency
            }
            goodsValue {
              price,
              currency
            }
            arrivalUTC
            departureUTC
          }
          ...on ShipmentCustom {
            id
            labels
            status
            createdAt
            updatedAt
            warnings
            type
            providerName
            pickupLocal {
              from
              to
            }
            deliveryLocal {
              from
              to
            }
            arrivalUTC
            departureUTC
            drops {
              weight
              volume
            }
            quoting {
              quotingStatus
              noOfRequests
              noOfQuotes
              selectedQuote {
                status
              }
            }
            pricing {
              price
              currency
            }
          }
          # ... on ShipmentRFR {
          #   id
          #   labels
          #   status
          #   createdAt
          #   updateAt
          #   warnings
          #   weight
          #   volume
          #   quotingStatus
          #   quoted
          #   vehicle {
          #     id
          #   }
          #   driver
          # }
          # ... on ShipmentAFR {
          #   id
          #   labels
          #   status
          #   createdAt
          #   updateAt
          #   warnings
          #   weight
          #   volume
          #   quotingStatus
          #   quotes
          # }
          # ... on ShipmentOFR {
          #   id
          #   labels
          #   status
          #   createdAt
          #   updateAt
          #   warnings
          #   weight
          #   volume
          #   quotingStatus
          #   quotes
          #   vehicle
          # }
        }
      }
    }
    total
    ranges {
      type
      from
      to
    }
  }
}`

async function Shipments ({ query = '', resource = 'ShipmentType', filters, pageSize = 50, rangeFilters }) {
  try {
    const response = await appSync.query({
      query: SEARCH_SHIPMENTS,
      variables: {
        input: {
          // query,
          resource,
          filters,
          rangeFilters,
          // page,
          pageSize
        }
      },
      fetchPolicy: 'no-cache'
    })
    return { items: response.data.search.results, total: response.data.search.total , ranges: response.data.search.ranges}
  } catch (error) {
    return Promise.reject(error)
  }
}

const SEARCH_SHIPMENTS_FACETS = gql`query searchFacets($input: SearchFacetInput!) {
  searchFacets(input: $input) {
    results {
      value
      count
    }
  }
}`

async function ShipmentsFacets({ query, resource, facet, filters, pageSize, rangeFilters }) {
  try {
    const response = await appSync.query({
      query: SEARCH_SHIPMENTS_FACETS,
      variables: {
        input: {
          query,
          resource,
          facet,
          filters,
          pageSize,
          rangeFilters
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response.data.searchFacets.results === null ? [] : response.data.searchFacets.results
  } catch (error) {
    return  Promise.reject(error)
  }
}


// Shipment Mutations

const SET_GOODS_VALUE_BY_DAY = gql`mutation setGoodsValue($input: SetGoodsValueInput!) {
  setGoodsValue(input: $input) {
    err
  }
}`
